// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RapidReviewAcuityResponse } from './rapid-review-acuity-response';

// @ts-ignore
import { RapidReviewAllergyResponse } from './rapid-review-allergy-response';

// @ts-ignore
import { RapidReviewFamilyHistoryResponse } from './rapid-review-family-history-response';

// @ts-ignore
import { RapidReviewMedicationResponse } from './rapid-review-medication-response';

// @ts-ignore
import { RapidReviewOcularHistoryResponse } from './rapid-review-ocular-history-response';

// @ts-ignore
import { RapidReviewPresentIllnessResponse } from './rapid-review-present-illness-response';

// @ts-ignore
import { RapidReviewReasonForVisitResponse } from './rapid-review-reason-for-visit-response';

// @ts-ignore
import { RapidReviewReviewOfSystemsResponse } from './rapid-review-review-of-systems-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewHistoryResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewHistoryResponse extends GandalfModelBase {

	@GandalfProperty({ designType: RapidReviewAcuityResponse })
	aidedVisualAcuity!: RapidReviewAcuityResponse | null;

	@GandalfArray(RapidReviewAllergyResponse)
	allergies!: RapidReviewAllergyResponse[];

	@GandalfProperty({ designType: Number })
	encounterId!: number;

	@GandalfProperty({ designType: RapidReviewFamilyHistoryResponse })
	familyHistory!: RapidReviewFamilyHistoryResponse | null;

	@GandalfArray(RapidReviewMedicationResponse)
	medications!: RapidReviewMedicationResponse[];

	@GandalfProperty({ designType: RapidReviewOcularHistoryResponse })
	ocularHistory!: RapidReviewOcularHistoryResponse | null;

	@GandalfArray(RapidReviewPresentIllnessResponse)
	presentIllnesses!: RapidReviewPresentIllnessResponse[];

	@GandalfProperty({ designType: RapidReviewReasonForVisitResponse })
	reasonForVisit!: RapidReviewReasonForVisitResponse | null;

	@GandalfProperty({ designType: RapidReviewReviewOfSystemsResponse })
	reviewOfSystems!: RapidReviewReviewOfSystemsResponse | null;

	@GandalfProperty({ designType: RapidReviewAcuityResponse })
	uncorrectedVisualAcuity!: RapidReviewAcuityResponse | null;

}
